import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
const placeholder2 = require("../../assets/image (7).jpg");
const placeholder3 = require("../../assets/image (21).jpg");
const placeholder4 = require("../../assets/image (9).jpg");
import { SecondaryButton2 } from "./Buttons";


const AboutFeatures = () => (

  <section className="px-4 bg-gray-50 py-25">
  {/* First Section */}
  <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-1 items-center min-h-[120px] md:min-h-[160px] lg:min-h-[220px]">

    <img
      src={placeholder2}
      alt="Happy child"
      className="object-cover w-1/3 h-56 md:h-64 lg:h-72 rounded-full shadow-md mx-auto transition-transform duration-250 ease-in-out hover:-translate-y-1"
    />
    <div className="p-1">
      <h2 className="text-xl sm:text-2xl font-extrabold mb-1">
        Children Come to Know <br /> and Be Known
      </h2>
      <p className="text-gray-700 mb-2 text-justify text-sm md:text-base">
        Spectrum Nurturing Academy Believes that all children have the right to
        develop, to be fully known hearts and minds, and to be understood
        deeply. 
        If you are searching for a cutting-edge educational program for 
        your typically developing child, or if your child has special
        abilities, our Relationship based Developmental Educational
        Model is a dynamic, educational and above all, a fun way for
        children to learn and grow. At Spectrum Nurturing Academy Developmental
        Learning Center children, parents and educators journey
        together!
      </p>
       <Link to="/contact">
              <SecondaryButton2 label="Contact Us" />
            </Link>
              
    </div>
  </div>

  {/* Second Section */}
  <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-1 items-center min-h-[120px] md:min-h-[160px] lg:min-h-[220px]">
    <div className="p-1">
      <h2 className="text-xl sm:text-2xl font-extrabold mb-1">
        🌟 What Makes Us Different?
      </h2>
      <p className="text-gray-700 mb-2 text-justify text-sm md:text-base">
        🧠 ASD-Friendly, Value-Based Curriculum At SNA, we’ve developed a unique 12-month character-building program where children learn core human values like Respect, Kindness, Responsibility, and Empathy through classroom activities, role-play, and visual supports—all carefully adapted for children with ASD.
      </p>
      <Link to="/contact">
              <SecondaryButton2 label="Contact Us" />
            </Link>
    </div>
    <img
      src={placeholder3}
      alt="Happy child"
      className="object-cover w-1/3 h-56 md:h-64 lg:h-72 rounded-full shadow-md mx-auto transition-transform duration-250 ease-in-out hover:-translate-y-1"
    />
  </div>


{/* Third Section */}
  <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-1 items-center min-h-[120px] md:min-h-[160px] lg:min-h-[220px]">
    <img
      src={placeholder4}
      alt="Happy child"
      className="object-cover w-1/3 h-56 md:h-64 lg:h-72 rounded-full shadow-md mx-auto transition-transform duration-250 ease-in-out hover:-translate-y-1"
    />
    <div className="p-1">
      <h2 className="text-xl sm:text-2xl font-extrabold mb-1">
         Each month focuses on one value, taught using tools like
       </h2>

        <ul className="mb-1 text-sm md:text-base">
           <li>Visual cues and emotion cards</li>
           <li>Social stories and puppets</li>
           <li>Structured routines and reinforcement systems</li>
           <li>Calm-down spaces and sensory-friendly activities</li>
         </ul>
<p className="text-gray-700 mb-2 text-justify text-sm md:text-base">
   This helps children not just understand values—but live them in a meaningful way.
   </p>

        <Link to="/contact"> <SecondaryButton2 label="Contact Us" /> </Link>

      </div>
    </div>

      <div className="pb-25"></div>


 </section>

 );

 export default AboutFeatures;
